



// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../../context/AuthContext';
// import { FaBuilding, FaLock, FaEnvelope } from 'react-icons/fa';
// import toast from 'react-hot-toast';

// const Login = () => {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [loading, setLoading] = useState(false);
//   const { signIn, user } = useAuth();
//   const navigate = useNavigate();

//   // Debug: Log current auth state
//   useEffect(() => {
//     console.log('Login component mounted - Current user:', user);
//     console.log('Token in localStorage:', localStorage.getItem('token'));
//   }, [user]);

//   // Redirect if already logged in
//   useEffect(() => {
//     if (user && user.role === 'admin') {
//       console.log('Login component - User is admin, redirecting to /admin');
//       navigate('/admin');
//     }
//   }, [user, navigate]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!email || !password) {
//       toast.error('Please enter both email and password');
//       return;
//     }
    
//     console.log('Login form submitted with:', email);
//     setLoading(true);

//     try {
//       const result = await signIn(email, password);
//       console.log('signIn result:', result);
      
//       if (result.success) {
//         toast.success('Login successful! Redirecting...');
//         console.log('Login successful, user:', result.user);
        
//         // Wait for state to update, then navigate
//         setTimeout(() => {
//           console.log('Navigating to /admin');
//           navigate('/admin');
//         }, 100);
//       } else {
//         console.log('Login failed with message:', result.message);
//       }
//     } catch (error) {
//       console.error('Login unexpected error:', error);
//       toast.error('An unexpected error occurred');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-gray-100 flex items-center justify-center p-4">
//       <div className="max-w-md w-full">
//         {/* Card */}
//         <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
//           {/* Header */}
//           <div className="bg-gradient-to-r from-blue-600 to-blue-800 p-8 text-center">
//             <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full mb-6">
//               <FaBuilding className="h-8 w-8 text-blue-600" />
//             </div>
//             <h1 className="text-3xl font-bold text-white mb-2">Brasotech Admin</h1>
//             <p className="text-blue-100">Sign in to manage company content</p>
//           </div>

//           {/* Form */}
//           <div className="p-8">
//             <form onSubmit={handleSubmit} className="space-y-6">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Email Address
//                 </label>
//                 <div className="relative">
//                   <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                     <FaEnvelope className="h-5 w-5 text-gray-400" />
//                   </div>
//                   <input
//                     type="email"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                     placeholder="admin@brasotech.com"
//                     required
//                   />
//                 </div>
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Password
//                 </label>
//                 <div className="relative">
//                   <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                     <FaLock className="h-5 w-5 text-gray-400" />
//                   </div>
//                   <input
//                     type="password"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                     placeholder="••••••••"
//                     required
//                   />
//                 </div>
//               </div>

//               <div>
//                 <button
//                   type="submit"
//                   disabled={loading}
//                   className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white py-3 px-4 rounded-lg hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 font-medium"
//                 >
//                   {loading ? (
//                     <span className="flex items-center justify-center">
//                       <svg className="animate-spin h-5 w-5 mr-3 text-white" viewBox="0 0 24 24">
//                         <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
//                         <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
//                       </svg>
//                       Signing in...
//                     </span>
//                   ) : (
//                     'Sign In'
//                   )}
//                 </button>
//               </div>
//             </form>

//             {/* Demo Info */}
//             <div className="mt-8 pt-8 border-t border-gray-200">
//               <p className="text-sm text-gray-600 text-center">
//                 For demo purposes, use default admin credentials
//               </p>
//             </div>

//             {/* Back to Home */}
//             <div className="mt-6 text-center">
//               <a
//                 href="/"
//                 className="text-blue-600 hover:text-blue-800 font-medium"
//               >
//                 ← Back to Homepage
//               </a>
//             </div>

//             {/* DEBUG BUTTON - Remove after fixing */}
//             <div className="mt-6 text-center">
//               <button
//                 onClick={() => {
//                   console.log('=== DEBUG ===');
//                   console.log('LocalStorage token:', localStorage.getItem('token'));
//                   console.log('LocalStorage user:', localStorage.getItem('user'));
//                   console.log('AuthContext user:', user);
//                   navigate('/admin');
//                 }}
//                 className="text-sm text-gray-500 hover:text-gray-700"
//               >
//                 Debug Login State
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Footer Note */}
//         <div className="mt-8 text-center">
//           <p className="text-sm text-gray-600">
//             © {new Date().getFullYear()} Brasotech Investments Limited
//           </p>
//           <p className="text-xs text-gray-500 mt-1">
//             Company Registration No. 73012
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;







import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FaLock, FaEnvelope } from 'react-icons/fa';
import toast from 'react-hot-toast';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn, user } = useAuth();
  const navigate = useNavigate();

  // Debug: Log current auth state
  useEffect(() => {
    console.log('Login component mounted - Current user:', user);
    console.log('Token in localStorage:', localStorage.getItem('token'));
  }, [user]);

  // Redirect if already logged in
  useEffect(() => {
    if (user && user.role === 'admin') {
      console.log('Login component - User is admin, redirecting to /admin');
      navigate('/admin');
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      toast.error('Please enter both email and password');
      return;
    }
    
    console.log('Login form submitted with:', email);
    setLoading(true);

    try {
      const result = await signIn(email, password);
      console.log('signIn result:', result);
      
      if (result.success) {
        toast.success('Login successful! Redirecting...');
        console.log('Login successful, user:', result.user);
        
        // Wait for state to update, then navigate
        setTimeout(() => {
          console.log('Navigating to /admin');
          navigate('/admin');
        }, 100);
      } else {
        console.log('Login failed with message:', result.message);
      }
    } catch (error) {
      console.error('Login unexpected error:', error);
      toast.error('An unexpected error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-gray-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Card */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Header with Company Logo */}
          <div className="bg-gradient-to-r from-blue-600 to-blue-800 p-8 text-center">
            <div className="flex flex-col items-center mb-6">
              {/* Company Logo */}
              <div className="mb-4">
                <img 
                  src="/company_logo.jpg" // Path to your company logo
                  alt="Brasotech Investments Logo"
                  className="h-16 w-auto mx-auto rounded-lg shadow-sm"
                  onError={(e) => {
                    e.target.onerror = null; // Prevent infinite loop
                    // Fallback to text if logo fails to load
                    e.target.style.display = 'none';
                    const parent = e.target.parentElement;
                    if (parent) {
                      const fallback = document.createElement('div');
                      fallback.className = 'h-16 w-16 bg-gradient-to-r from-blue-400 to-blue-600 rounded-lg flex items-center justify-center text-white font-bold text-xl shadow-sm';
                      fallback.textContent = 'BI';
                      parent.insertBefore(fallback, parent.firstChild);
                    }
                  }}
                />
              </div>
              <div>
                <h1 className="text-3xl font-bold text-white mb-2">Brasotech</h1>
                <p className="text-blue-100 text-lg font-medium">Investments Limited</p>
                <p className="text-blue-200 text-sm mt-2">Admin Portal</p>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="p-8">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Email Address
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FaEnvelope className="h-5 w-5 text-gray-400" />
                  </div>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="admin@brasotech.com"
                    required
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Password
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FaLock className="h-5 w-5 text-gray-400" />
                  </div>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="••••••••"
                    required
                  />
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white py-3 px-4 rounded-lg hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 font-medium"
                >
                  {loading ? (
                    <span className="flex items-center justify-center">
                      <svg className="animate-spin h-5 w-5 mr-3 text-white" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                      </svg>
                      Signing in...
                    </span>
                  ) : (
                    'Sign In'
                  )}
                </button>
              </div>
            </form>

            {/* Demo Info */}
            <div className="mt-8 pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-600 text-center">
                For demo purposes, use default admin credentials
              </p>
            </div>

            {/* Back to Home */}
            <div className="mt-6 text-center">
              <a
                href="/"
                className="text-blue-600 hover:text-blue-800 font-medium inline-flex items-center"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                Back to Homepage
              </a>
            </div>

            {/* DEBUG BUTTON - Remove after fixing */}
            <div className="mt-6 text-center">
              <button
                onClick={() => {
                  console.log('=== DEBUG ===');
                  console.log('LocalStorage token:', localStorage.getItem('token'));
                  console.log('LocalStorage user:', localStorage.getItem('user'));
                  console.log('AuthContext user:', user);
                  navigate('/admin');
                }}
                className="text-sm text-gray-500 hover:text-gray-700"
              >
                Debug Login State
              </button>
            </div>
          </div>
        </div>

        {/* Footer Note */}
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-600">
            © {new Date().getFullYear()} Brasotech Investments Limited
          </p>
          <p className="text-xs text-gray-500 mt-1">
            
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;